import { useCallback, useEffect, useRef, useState } from "react";
import { openReportIssue, useReportIssueStore } from "../../store/reportIssueStore";

/** Each toast owner keeps its generation; a report can clear only the captured error. */
export function useReportIssueToast(reportable: boolean) {
  const [open, setVisible] = useState(false);
  const current = useRef({ open: false, generation: 0, reportable });
  current.current.reportable = reportable;
  const setOpen = useCallback((next: boolean) => {
    current.current.open = next;
    current.current.generation += 1;
    setVisible(next);
  }, []);

  useEffect(() => {
    let captured: { session: number; generation: number } | null = null;
    return useReportIssueStore.subscribe((state, previous) => {
      if (state.open && state.modalSessionId !== previous.modalSessionId) {
        captured = current.current.open && current.current.reportable
          ? { session: state.modalSessionId, generation: current.current.generation }
          : null;
      }
      if (captured && state.sentSessionId !== previous.sentSessionId &&
          state.sentSessionId === captured.session &&
          current.current.open && current.current.reportable &&
          current.current.generation === captured.generation) {
        captured = null;
        setOpen(false);
      }
      if (!state.open) captured = null;
    });
  }, [setOpen]);

  const report = useCallback(() => {
    setOpen(false);
    openReportIssue("toast");
  }, [setOpen]);
  return [open, setOpen, report] as const;
}
